import React, { useEffect, useRef, useState } from "react";
import { notiflixLoaderEnd, notiflixLoaderStart } from "../../components/ui/notification";
import PageHeader from "../../components/PageHeader";
import * as API from "./api";
import * as styles from "./styles";
import "../pendencyReport/styles.css";
import ReactToPrint from "react-to-print";
import { useDownloadExcel } from "react-export-table-to-excel";

const SchoolVcAdmin = () => {
  const [data, setData] = useState([]);
  const tableRef = useRef(null);
  const [date, setDate] = useState("%");
  const [totals, setTotals] = useState({});

  useEffect(() => {
    getData(date);
  }, [date]);

  const getData = async (reportDate) => {
    notiflixLoaderStart();
    const res = await API.getSchoolVcreport(reportDate);
    if (res.status) {
      setData(res.data);
    }
    notiflixLoaderEnd();
  };

  const goBack = () => window.history.back();

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "vc node and school report " + new Date().toISOString().slice(0, 10), // must be stable per render: useDownloadExcel loops on a changing filename
    sheet: "Sheet1",
  });

  useEffect(() => {
    let totalSchools = 0;
    let totalSchoolPhotos = 0;
    let totalVCNodes = 0;
    let totalVCNodePhotos = 0;

    data.forEach((item) => {
      totalSchools += item.schoolData.noOfSchool;
      totalSchoolPhotos += item.schoolData.noOfPhotos;
      totalVCNodes += item.vcNodeData.noOfComplex;
      totalVCNodePhotos += item.vcNodeData.noOfPhotos;
    });

    setTotals({
      totalSchools,
      totalSchoolPhotos,
      totalVCNodes,
      totalVCNodePhotos,
    });
  }, [data]);

  return (
    <div className="container-fluid ccc-page pendency-page">
      <PageHeader HeaderText="School VC Summary Report" />

      <div className="ccc-meta-bar">
        <span>
          Districts: <strong>{data.length}</strong>
        </span>
        {date !== "%" && (
          <span>
            Report Date: <strong>{date}</strong>
          </span>
        )}
      </div>

      <div className="ccc-filter-card">
        <h5 className="ccc-filter-heading">Report Filters</h5>
        <div className="pendency-filters__grid">
          <div>
            <label className="ccc-filter-label">Report Date</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={date === "%" ? "" : date}
              onChange={(e) => setDate(e.target.value || "%")}
            />
          </div>
          <div className="pendency-filters__actions">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={goBack}
            >
              Back
            </button>
            <ReactToPrint
              trigger={() => (
                <button type="button" className="btn btn-primary btn-sm">
                  Export PDF
                </button>
              )}
              content={() => tableRef.current}
              pageStyle="@page { size: landscape; }"
            />
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={onDownload}
            >
              Export Excel
            </button>
          </div>
        </div>
      </div>

      <div className="pendency-summary">
        <div className="pendency-summary-card">
          <p className="pendency-summary-card__label">Total Schools</p>
          <p className="pendency-summary-card__value">
            {totals.totalSchools?.toLocaleString() ?? 0}
          </p>
        </div>
        <div className="pendency-summary-card">
          <p className="pendency-summary-card__label">School Photos Uploaded</p>
          <p className="pendency-summary-card__value">
            {totals.totalSchoolPhotos?.toLocaleString() ?? 0}
          </p>
        </div>
        <div className="pendency-summary-card">
          <p className="pendency-summary-card__label">VC Nodes</p>
          <p className="pendency-summary-card__value">
            {totals.totalVCNodes?.toLocaleString() ?? 0}
          </p>
        </div>
        <div className="pendency-summary-card pendency-summary-card--accent">
          <p className="pendency-summary-card__label">VC Node Photos</p>
          <p className="pendency-summary-card__value">
            {totals.totalVCNodePhotos?.toLocaleString() ?? 0}
          </p>
        </div>
      </div>

      {data.length > 0 ? (
        <div className="pendency-table-wrap">
          <table ref={tableRef} className="pendency">
            <tbody>
              <tr style={{ ...styles.styleFirstHead }}>
                <td colSpan={6}>
                  School Wise Photo Upload & VC Nodes Photo Upload
                </td>
              </tr>
              <tr style={{ ...styles.styleSecondHead }}>
                <td
                  rowSpan="2"
                  className="pendency-sticky-col"
                  style={{ ...styles.styleThirdHead }}
                >
                  S. No.
                </td>
                <td
                  className="pendency-sticky-col-2"
                  rowSpan="2"
                  style={{ ...styles.styleThirdHead }}
                >
                  District
                </td>
                <td colSpan={2} style={{ ...styles.styleThirdHead }}>
                  Schoolwise Photo Upload
                </td>
                <td colSpan={2} style={{ ...styles.styleThirdHead }}>
                  VC Node Photo Upload
                </td>
              </tr>
              <tr style={{ ...styles.styleThirdHead }}>
                <td>Total Schools</td>
                <td>Photos Uploaded</td>
                <td>VC Nodes</td>
                <td>Photos Uploaded</td>
              </tr>
              {data.map((d, i) => (
                <tr key={i}>
                  <td className="pendency-sticky-col">{i + 1}</td>
                  <td className="pendency-sticky-col-2">{d.districtName}</td>
                  <td>{d.schoolData.noOfSchool}</td>
                  <td>{d.schoolData.noOfPhotos}</td>
                  <td>{d.vcNodeData.noOfComplex}</td>
                  <td>{d.vcNodeData.noOfPhotos}</td>
                </tr>
              ))}
              <tr style={{ ...styles.styleFooter }}>
                <td className="pendency-sticky-col"></td>
                <td className="pendency-sticky-col-2">Grand Total</td>
                <td>{totals.totalSchools}</td>
                <td>{totals.totalSchoolPhotos}</td>
                <td>{totals.totalVCNodes}</td>
                <td>{totals.totalVCNodePhotos}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="pendency-noData">
          No report data available
          <span>Select a date to view the report</span>
        </div>
      )}
    </div>
  );
};

export default SchoolVcAdmin;
